var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import React, { Component, Fragment, } from 'react';
import { HtmlButton } from '../../reset';
import { VisuallyHidden } from '../Visually-hidden/Visually-hidden';
import classnames from 'classnames';
import styled from 'styled-components';
import { disabledCursor } from '../utils/css';
var baseClassName = 'fi-button';
var disabledClassName = baseClassName + "--disabled";
export var mouseNonFocus = function (_a) {
    var handleClick = _a.handleClick;
    var doClick = function (e) {
        if (!!e) {
            e.preventDefault();
        }
        handleClick(e);
    };
    var keyboard = { enter: 13, space: 32 };
    var ifKeyboard = function (e) {
        return (e.keyCode === keyboard.enter || e.keyCode === keyboard.space) &&
            doClick(e);
    };
    return { onMouseDown: doClick, onKeyUp: ifKeyboard };
};
var Assertive = (function (_super) {
    __extends(Assertive, _super);
    function Assertive() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { unDisabled: false };
        return _this;
    }
    Assertive.prototype.componentDidUpdate = function (prevProps) {
        var disabled = this.props.disabled;
        if (disabled !== prevProps.disabled) {
            this.setState({ unDisabled: !disabled });
        }
    };
    Assertive.prototype.render = function () {
        var _a = this.props, ariaAssertiveDisabled = _a.ariaAssertiveDisabled, ariaAssertiveUnDisabled = _a.ariaAssertiveUnDisabled;
        var unDisabled = this.state.unDisabled;
        if (!ariaAssertiveDisabled && !ariaAssertiveUnDisabled)
            return null;
        var text = !!unDisabled ? ariaAssertiveUnDisabled : ariaAssertiveDisabled;
        return !!text ? (React.createElement(VisuallyHidden, { "aria-live": "assertive" }, text)) : null;
    };
    return Assertive;
}(Component));
export { Assertive };
var StyledHtmlButton = styled(function (props) { return (React.createElement(HtmlButton, __assign({}, props))); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.", " {\n    ", "\n  }\n"], ["\n  &.", " {\n    ", "\n  }\n"])), disabledClassName, disabledCursor);
var Button = (function (_super) {
    __extends(Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Button.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, _c = _b.disabled, disabled = _c === void 0 ? false : _c, mouseNoFocus = _b.mouseNoFocus, onClick = _b.onClick, ariaAssertiveDisabled = _b.ariaAssertiveDisabled, ariaAssertiveUnDisabled = _b.ariaAssertiveUnDisabled, passProps = __rest(_b, ["className", "disabled", "mouseNoFocus", "onClick", "ariaAssertiveDisabled", "ariaAssertiveUnDisabled"]);
        var ifMouseNoFocus = !!mouseNoFocus && !!onClick
            ? function () {
                var doClick = mouseNonFocus({ handleClick: onClick });
                return {
                    onMouseDown: doClick.onMouseDown,
                    onKeyUp: doClick.onKeyUp,
                };
            }
            : function () { return ({ onClick: onClick }); };
        var onClickProps = !!disabled ? {} : ifMouseNoFocus();
        return (React.createElement(Fragment, null,
            React.createElement(StyledHtmlButton, __assign({}, passProps, onClickProps, { "aria-disabled": disabled, tabIndex: 0, className: classnames(baseClassName, className, (_a = {},
                    _a[disabledClassName] = !!disabled,
                    _a)) })),
            React.createElement(Assertive, { disabled: disabled, ariaAssertiveDisabled: ariaAssertiveDisabled, ariaAssertiveUnDisabled: ariaAssertiveUnDisabled })));
    };
    return Button;
}(Component));
export { Button };
var templateObject_1;
//# sourceMappingURL=Button.js.map